(function() {
    "use strict";

    angular.module("sempraWebapp").factory("CampaignItemViewModel", CampaignItemViewModelFactory);

    /** @ngInject */
    function CampaignItemViewModelFactory(DateTime) {
        function CampaignItemViewModel(campaignJson, userGroupsArrayJson) {
            this.id = campaignJson.id;
            this.name = campaignJson.name;
            this.from = campaignJson.from;
            this.isInFuture = campaignJson.isInFuture;
            this.to = campaignJson.to;
            this.isInDateRange =
                new DateTime().timestamp < campaignJson.to && new DateTime().timestamp > campaignJson.from;
            this.isActive = campaignJson.active;
            this.activateEnabled = this.isInDateRange && !this.isActive;

            // money rule
            if (typeof campaignJson.moneyRule !== "undefined") {
                this.hasAmountOfMoneyRule = campaignJson.moneyRule.moneySpent.amount ? true : false;
            }

            // visit rule
            if (typeof campaignJson.visitsRule !== "undefined") {
                this.hasNumberOfVisitsRule = campaignJson.visitsRule.visits ? true : false;
            }

            // if is set one of those rules and campaign is active, set treshold to true
            if (typeof this.hasAmountOfMoneyRule !== "undefined" && typeof this.hasNumberOfVisitsRule !== "undefined") {
                this.tresholdEnabled = (this.hasAmountOfMoneyRule || this.hasNumberOfVisitsRule) && this.isActive;
            }

            if (campaignJson.temporalRule) {
                this.facilityType = campaignJson.temporalRule.deviceType;
            }

            this.userGroups = userGroupsArrayJson.filter(function(userGroupJson) {
                return campaignJson.userGroupIds.indexOf(userGroupJson.id) > -1;
            });

            init.call(this);
        }

        CampaignItemViewModel.prototype.destroy = function() {};

        CampaignItemViewModel.prototype.activateCampaign = function() {
            this.isActive = true;
            this.activateEnabled = false;
            this.tresholdEnabled = (this.hasAmountOfMoneyRule || this.hasNumberOfVisitsRule) && this.isActive;
        };

        return CampaignItemViewModel;

        function init() {
            refresh.call(this);
        }

        function refresh() {}
    }
})();
